import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Right } from '../models/Rights.enum';
import { LoaderService } from '../services/loader.service';
import { TrackingService } from '../services/tracking.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'fs-home',
  styleUrls: ['./home.sass'],
  templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit {
  rights = Right;
  lateBillsNb;
  rcuId: string | null;
  eInvoicingUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private trackingService: TrackingService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.rcuId = this.userService.RcuId;
    this.eInvoicingUrl = `https://cloud.pro.seloger.com/e-invoicing/declaration?rcu=${this.rcuId}`;

    this.activatedRoute.data.subscribe(resolvedData => {
      this.lateBillsNb = resolvedData.lateBillsNb;
      this.trackingService.pushEvent('financial-homepage');
      this.trackingService.pushPageViewGA4('financial_homepage');
      this.loaderService.decreaseLoaderCount();
    });
  }

}
